import { faAward } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { ColorValue } from 'react-native';

import { useAppSelector } from '../../../hooks/store-hook';
import useTranslation from '../../../hooks/translation-hook';
import MoreInfoButton, { MoreInfoButtonProps } from '../MoreInfoButton';
import { formatMissionCurrency } from '../../../helpers/missionCompensation';
import MissionCompensationRow from './MissionCompensationRow';

interface MissionRemunerationSummaryProps {
  amount?: number | string;
  points?: number;
  pointsOnly?: boolean;
  label?: string;
  totalPaymentMaxAmount?: number | null;
  textColor?: ColorValue;
  iconColor?: ColorValue;
  helpColor?: string;
  moreInfoButtonProps?: Pick<MoreInfoButtonProps, 'suspendDrawerOnOpen' | 'useLightBoxOnNative' | 'onOpen'>;
}

const MissionRemunerationSummary = ({ amount, points, pointsOnly = false, label, totalPaymentMaxAmount, textColor, iconColor, helpColor, moreInfoButtonProps }: MissionRemunerationSummaryProps) => {
  const t = useTranslation();
  const uiLanguage = useAppSelector((state) => state.userPrefs.uiLanguage);
  const localizedAmount = formatMissionCurrency(amount, uiLanguage);
  const totalPaymentLimit = typeof totalPaymentMaxAmount === 'number' && Number.isFinite(totalPaymentMaxAmount)
    ? t('at-home-total-payment-cap', {
      amount: new Intl.NumberFormat(uiLanguage?.startsWith('fr') ? 'fr-CA' : 'en-CA', {
        style: 'currency', currency: 'CAD',
      }).format(totalPaymentMaxAmount),
    })
    : undefined;
  const helpText = [t('help.points-rate'), totalPaymentLimit].filter(Boolean).join('\n\n');

  return <MissionCompensationRow icon={faAward} large
    heading={pointsOnly ? t('points-value', { value: points ?? 0 }) : localizedAmount}
    caption={`${label ?? t('salary')}${!pointsOnly && points !== undefined ? ` (${points} pts)` : ''}`}
    color={textColor} iconColor={iconColor}
    help={<MoreInfoButton {...moreInfoButtonProps} style={{ width: 32, height: 32, justifyContent: 'center' }}
      title="" color={helpColor} openURL="rewards-link-lanla-website-support">
      {helpText}
    </MoreInfoButton>} />;
};

export default MissionRemunerationSummary;
